import i18next from 'i18next';
import { percent } from '../helpers';
import { type SaveLearnFlowChartData } from './types';

export const saveflowPlusLearnflowStats = (theme: any) => (data: SaveLearnFlowChartData) => ({
  title: `${i18next.t('historical use', { ns: 'overview' })}: ${i18next.t('common:learnflow')}`,
  data: [
    {
      id: 'learnflowUsage',
      label: i18next.t('have taken classes'),
      legend: i18next.t('common:learnflow'),
      color: [theme.palette.colorPalette[3], theme.palette.colorPalette[2], theme.palette.colorPalette[1]],
      value: data?.featuresDisabled ? 0 : percent(data?.learnflowCount, data?.activeCount) || 0
    }
  ]
});

export const saveflowStats = (theme: any) => (data: SaveLearnFlowChartData) => ({
  title: `${i18next.t('historical use', { ns: 'overview' })}: ${i18next.t('common:saveflow')}`,
  data: [
    {
      id: 'saveflowUsage',
      label: i18next.t('have saved'),
      legend: i18next.t('common:saveflow'),
      color: [theme.palette.colorPalette[2], theme.palette.colorPalette[3]],
      value: data?.featuresDisabled ? 0 : percent(data?.saveflowCount, data?.activeCount) || 0
    }
  ]
});

export const learnflowStats = (theme: any) => (data: SaveLearnFlowChartData) => ({
  title: `${i18next.t('historical use', { ns: 'overview' })}: ${i18next.t('common:learnflow')}`,
  data: [
    {
      id: 'learnflowUsage',
      label: i18next.t('have taken classes'),
      legend: i18next.t('common:learnflow'),
      color: [theme.palette.colorPalette[3], theme.palette.colorPalette[2], theme.palette.colorPalette[1]],
      value: data?.featuresDisabled ? 0 : percent(data?.learnflowCount, data?.activeCount) || 0
    }
  ]
});
